import { floatify, getToday } from '@anytag/shared-utils';
import { EngagementPostEditV2, EngagementPostMissingMetrics } from '@anytag/graphql';
import { EngagementPostFormValues } from './types';

export const getEngagementPostFormValues = (
  post?: Partial<EngagementPostEditV2> | null,
  postMissingMetricsData?: EngagementPostMissingMetrics | null
): EngagementPostFormValues => {
  const socialAccountMedia = post?.influencer?.socialAccountMedia || '';
  const socialAccountId = String(post?.influencer?.socialAccountId || '');

  return {
    socialAccountId,
    socialAccountMedia,
    socialPostMedia: post?.socialMedia || '',
    id: post?.id,
    isTtcmForm: false,
    content: post?.content || '',
    postUrl: post?.postUrl || '',
    insightUrls: [...(post?.insightUrls || [])],
    influencerId: String(post?.influencer?.id || ''),
    materialsUrl: post?.materials?.map(({ url }) => url) || [],
    insightDataAcquisition: post?.insightDataAcquisition || getToday(),
    selectedAccount: socialAccountId && socialAccountMedia ? `${socialAccountId}-${socialAccountMedia}` : '',
    // override metrics fields
    likes: String(postMissingMetricsData?.likes ?? ''),
    saves: String(postMissingMetricsData?.saves ?? ''),
    reach: String(postMissingMetricsData?.reach ?? ''),
    views: String(postMissingMetricsData?.views ?? ''),
    shares: String(postMissingMetricsData?.shares ?? ''),
    comments: String(postMissingMetricsData?.comments ?? ''),
    dislikes: String(postMissingMetricsData?.dislikes ?? ''),
    impressions: String(postMissingMetricsData?.impressions ?? ''),
    totalPlayTime: String(postMissingMetricsData?.totalPlayTime ?? ''),
    avgWatchTimes: String(postMissingMetricsData?.avgWatchTimes ?? ''),
    detailExpands: String(postMissingMetricsData?.detailExpands ?? ''),
    fullVideoViews: String(postMissingMetricsData?.fullVideoViews ?? ''),
    impressionsClickThroughRate:
      typeof postMissingMetricsData?.impressionsClickThroughRate === 'number'
        ? floatify(postMissingMetricsData?.impressionsClickThroughRate * 100).toString()
        : '',
    avgPlayRate:
      typeof postMissingMetricsData?.avgPlayRate === 'number'
        ? floatify(postMissingMetricsData?.avgPlayRate * 100).toString()
        : '',
    audienceRetention:
      typeof postMissingMetricsData?.audienceRetention === 'number'
        ? floatify(postMissingMetricsData?.audienceRetention * 100).toString()
        : ''
  };
};
